<template>
  <div class="navigation-container">
    <nav id="navigation-links">
      <template v-for="(item, index) of navigationItems" :key="index">
        <div
          v-if="item.link && item.enabled"
          class="navigation-item"
          :class="[{ active: hash == item.link }, { 'has-submenu': item.submenu && item.submenu.length }]"
        >
          <router-link
            class="navigation-link"
            :class="[{ active: hash == item.link }, { 'has-submenu': item.submenu && item.submenu.length }]"
            :to="item.link"
            @click="replaceByHash(item.link)"
          >
            <div>
              <template v-if="navbarActive">
                <i v-if="item.icon" :class="`bi bi-${item.icon}`"></i>
              </template>
              <template v-else>
                <i v-if="item.icon" :class="`bi bi-${item.icon}`" v-b-tooltip.hover.right.html="item"></i>
              </template>
              <span>{{ item.title }}</span>
            </div>
          </router-link>
          <div class="submenu" v-if="item.submenu">
            <template v-for="(subItem, ix) of item.submenu" :key="ix">
              <router-link
                v-if="subItem.enabled"
                :to="subItem.link"
                class="navigation-link"
                @click="replaceByHash(item.link)"
              >
                <div>
                  <template v-if="navbarActive">
                    <i v-if="subItem.icon" :class="`bi bi-${subItem.icon}`"></i>
                  </template>
                  <template v-else>
                    <i v-if="subItem.icon" :class="`bi bi-${subItem.icon}`" v-b-tooltip.hover.right.html="subItem"></i>
                  </template>
                  <span>{{ subItem.title }}</span>
                </div>
              </router-link>
            </template>
          </div>
        </div>
        <div
          v-else-if="item.hash && item.enabled"
          class="navigation-item"
          :class="[{ active: hash == item.hash }, { 'has-submenu': item.submenu && item.submenu.length }]"
        >
          <div
            class="navigation-link"
            :class="[{ active: hash == item.link }, { 'has-submenu': item.submenu && item.submenu.length }]"
            @click="replaceByHash(item.hash)"
          >
            <div>
              <template v-if="navbarActive">
                <i v-if="item.icon" :class="`bi bi-${item.icon}`"></i>
              </template>
              <template v-else>
                <i v-if="item.icon" :class="`bi bi-${item.icon}`" v-b-tooltip.hover.right.html="item"></i>
              </template>
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="submenu" v-if="item.submenu">
            <template v-for="(subItem, ix) of item.submenu" :key="ix">
              <router-link v-if="subItem.enabled" :to="subItem.link" class="navigation-link">
                <div>
                  <template v-if="navbarActive">
                    <i v-if="subItem.icon" :class="`bi bi-${subItem.icon}`"></i>
                  </template>
                  <template v-else>
                    <i v-if="subItem.icon" :class="`bi bi-${subItem.icon}`" v-b-tooltip.hover.right.html="subItem"></i>
                  </template>
                  <span>{{ subItem.title }}</span>
                </div>
              </router-link>
            </template>
          </div>
        </div>
      </template>
    </nav>
  </div>
</template>

<script>
import { isUserLoggedIn } from "@/auth/utils";

export default {
  props: {
    navbarActive: { type: Boolean, default: false },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      loggedIn: isUserLoggedIn(),
      hash: "",
      navigationItems: [
        {
          link: "/ulohy",
          title: this.$t("navigations.priklady"),
          icon: "calculator",
          permission: "CUSTOM_RESOURCES",
        },
        {
          link: "/kategorie-uloh",
          title: this.$t("priklad.categories"),
          icon: "diagram-2",
          permission: "CUSTOM_RESOURCE_CATEGORIES",
        },
        {
          link: "/strom-kategorii-uloh",
          title: this.$t("priklad.categoryTree"),
          icon: "diagram-3",
          permission: "CUSTOM_RESOURCE_CATEGORIES",
        },
        {
          link: "/testy",
          title: this.$t("test.plural"),
          icon: "journal-check",
          permission: "CUSTOM_RESOURCES",
        },
        {
          link: "/variables",
          title: this.$t("navigations.settings"),
          icon: "gear",
          submenu: [
            {
              link: "/variables",
              title: this.$t("navigations.variables"),
              icon: "gear-fill",
              permission: "ENVIRONMENT_VARIABLES",
            },
            {
              link: "/translations",
              title: this.$t("navigations.translations"),
              icon: "arrow-left-right",
              permission: "WEB_TRANSLATIONS",
            },
            {
              link: "/blocks",
              title: this.$t("navigations.blocks"),
              icon: "braces",
              permission: "JSON_BLOCKS",
            },
          ],
        },
        {
          link: "/logout",
          title: this.$t("navigations.logout"),
          icon: "door-open",
          enabled: true,
        },
      ],
    };
  },
  created() {
    if (this.userData) {
      this.traverse(this.navigationItems);
      for (const item of this.navigationItems) {
        if (item.link && item.submenu && !item.enabled) {
          const enabledSubItem = item.submenu.find((s) => s.enabled);
          if (enabledSubItem) {
            item.enabled = true;
            item.link = enabledSubItem.link;
          }
        }
        if (item.hash && item.submenu) {
          item.enabled = false;
          const enabledSubItem = item.submenu.find((s) => s.enabled);
          if (enabledSubItem) {
            item.enabled = true;
          }
        }
      }
    }
  },
  methods: {
    replaceByHash(hash) {
      this.hash = hash;
    },
    traverse(menu) {
      for (const item of menu) {
        if (item.enabled) {
          continue;
        }
        if (item.link) {
          let enabled = false;
          if (this.userData) {
            const existingPermission = this.userData.permissionRole?.permissions?.find(
              (p) => p.name === item.permission
            );
            if (existingPermission && existingPermission.LIST) {
              enabled = true;
            }
            if (["ROLE_SUPER_ADMIN", "ROLE_ADMIN"].includes(this.userData.role)) {
              enabled = true;
            }
            item.enabled = enabled;
          }
        }
        if (Object.prototype.hasOwnProperty.call(item, "submenu")) {
          this.traverse(item.submenu);
        }
      }
    },
  },
};
</script>
